export default {
    checkout: {
      started: 'Vamos começar',
      extra: 'Escolha seus extras',
      almost_there: 'Você está quase lá!',
      signin_google: 'Entrar com o Google',
      signin_chenosis: 'Entrar com',
      or: 'OU',
      login: 'Login',
      email: 'Seu e-mail',
      password: 'Sua senha',
      password_confirmation: 'Confirme sua senha',
      tip_email_verification: 'A verificação por e-mail é obrigatória para o endereço de e-mail fornecido.',
      welcome: 'Bem-vindo de volta',
      login_as: 'Você está logado como',
      not: 'Não',
      sign_out: 'Sair',
      sign_up_google: 'Inscreva-se com o Google',
      sign_up_chenosis: 'Inscreva-se com',
      sign_up: 'Inscreva-se',
      first_name: 'Seu nome',
      last_name: 'Seu sobrenome',
      email_registered: 'Seu endereço de e-mail já está registrado!',
      pick_another: 'ou escolha outro.',
      business: 'Você é uma empresa?',
      company: 'Nome da sua empresa',
      station_name: 'Conte-nos sobre sua estação.',
      station: 'Nome da estação',
      website: 'URL do site (opcional)',
      choose_extras: 'Escolha extras (opcional)',
      one_time: 'Uma vez',
      add_this: 'Adicionar isto',
      disclaimer_google: '(Aviso: conta do Google Play necessária, taxa única de $30)',
      included: 'Incluído',
      disclaimer_apple: '(Aviso: conta da App Store necessária, taxa anual de $100)',
      two_month_free: 'Ganhe 2 meses grátis!',
      annually_discount: 'Pague sua assinatura anualmente e obtenha 12 meses de serviço pelo preço de 10!',
      pay_annually: 'Pagar anualmente',
      chose_annual_pay: 'Você escolheu pagar pela sua estação anualmente.',
      charge_after_trial: 'será cobrado após o término do seu teste. Se preferir pagar mensalmente, clique',
      here: 'aqui',
      no_charging: '. Não se preocupe, você não será cobrado hoje. Você pode cancelar ou alterar sua assinatura facilmente a qualquer momento.',
      then_charge: 'então você será cobrado',
      trial_ends: 'Seu teste gratuito de 7 dias termina à meia-noite em',
      per: 'por',
      few_mention: 'Apenas algumas coisas para mencionar.',
      policy: 'Detalhes sobre como usamos as informações que você forneceu podem ser encontrados em nossos Termos e Política de Privacidade. Por favor, declare que leu ambos os documentos e concorda com estes termos antes de prosseguir. Você deve aceitar estes termos antes de usar nosso serviço.',
      confirm: 'Confirmo que li e concordo com o',
      agreement: 'Acordo de Privacidade',
      required: 'Este campo é obrigatório',
      back: 'Voltar',
      step: 'Passo',
      next: 'Próximo',
      select_plan: 'Plano Selecionado',
      storage: 'Armazenamento',
      listeners: 'Ouvintes',
      bandwidth: 'Largura de Banda',
      users: 'Usuários',
      return: 'Voltar para preços e planos',
      your_extras: 'Seus Extras',
      processing: 'Processando',
      start_trial: 'Iniciar teste gratuito',
    },
  };
  